<template>
  <div class="poll-vote-activity">
    <span class="poll-vote-activity__icon" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="8" width="3" height="6" rx="1" fill="#30A960"/>
        <rect x="6.5" y="5" width="3" height="9" rx="1" fill="#30A960"/>
        <rect x="11" y="2" width="3" height="12" rx="1" fill="#30A960"/>
      </svg>
    </span>
    <span class="poll-vote-activity__text">
      <span class="poll-vote-activity__name">{{ senderLabel }}</span>
      <span class="poll-vote-activity__muted"> tham gia cuộc bình chọn: </span>
      <span class="poll-vote-activity__title">{{ truncatedQuestion }}</span>
      <span class="poll-vote-activity__dot">.</span>
      <button type="button" class="poll-vote-activity__link" @click.stop="$emit('open-poll', payload)">Xem</button>
    </span>
  </div>
</template>

<script>
import { parsePollVoteSystemNote, truncatePollQuestion } from '@/helper/pollVoteMessages';

export default {
  name: 'PollVoteActivityMessage',
  props: {
    mess: {
      type: Object,
      required: true,
    },
    currentUserId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    note() {
      return parsePollVoteSystemNote(this.mess.system_note);
    },
    payload() {
      return {
        pollId: this.note.pollId,
        pollMessageId: this.note.pollMessageId,
        question: this.note.question,
      };
    },
    senderLabel() {
      if (!this.mess.sender) return 'Ai đó';
      return Number(this.mess.sender.id) === Number(this.currentUserId)
        ? 'Bạn'
        : (this.mess.sender.display_name || this.mess.sender.name || 'Ai đó');
    },
    truncatedQuestion() {
      return truncatePollQuestion(this.note.question, 56);
    },
  },
};
</script>

<style lang="scss" scoped>
.poll-vote-activity {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  max-width: min(100%, 720px);
  padding: 8px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e9eaec;
  box-shadow: 0 1px 2px rgba(47, 49, 54, 0.06);
  text-align: center;
  margin: 0 auto;
}

.poll-vote-activity__icon {
  flex: 0 0 auto;
  margin-top: 2px;
}

.poll-vote-activity__text {
  font-size: 13px;
  line-height: 18px;
  color: #65686c;
  font-weight: 500;
}

.poll-vote-activity__name,
.poll-vote-activity__muted,
.poll-vote-activity__title,
.poll-vote-activity__dot {
  color: #65686c;
  font-weight: 500;
}

.poll-vote-activity__link {
  border: 0;
  background: transparent;
  padding: 0;
  margin-left: 4px;
  color: #65686c;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
</style>
